import { ComponentType } from 'react';
import { Typography } from '@mui/material';
import { DirectionsEditForm, DirectionsEditFormProps } from '../directions-edit-form';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';

interface DirectionsEditDialogProps extends DirectionsEditFormProps {
  title?: string;
  popDialog?: any;
}

export const DirectionsEditDialog: ComponentType<DirectionsEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('directions.edit', 'Редактиовать направление')
    : t('directions.add', 'Добавить направление');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <DirectionsEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />
    </BaseDialog>
  );
};
